<template>
  <div>
    <div class="playlist-list" v-for="i in amountOfDisplayed" :key="i">
      <button class="playlist-info button-loading-bars">
        <div class="name">
          <div class="ph-item">
            <div class="ph-col-12">
              <div class="ph-row">
                <div class="big gold"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="lyricsCount">
          <h2 class="h2-loading-bars">
            <div class="ph-item">
            <div class="ph-col-12">
              <div class="ph-row">
                <div class="big"></div>
              </div>
            </div>
          </div>
          </h2>
        </div>
        <p class="font-size-small">Kliknij aby edytować lub usunąć</p>
      </button>
      <div class="border-background"></div>
      <div class="border-background-second"></div>
    </div>
  </div>
</template>

<script>
import '../../node_modules/placeholder-loading/src/scss/placeholder-loading.scss'

export default {
  name: 'LoadingPlaylistCards',
  props: {
    amount: {
      type: Number,
      require: true,
    },
  },
  data () {
    return {
      amountOfDisplayed: [],
    }
  },
  mounted () {
    let number = this.amount;
    for(let i = 0; i < number; i++) {
      this.amountOfDisplayed.push(i)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
  
.playlist-list {
  button {
    padding: 1px 0;
  }

  margin: 40px auto;
  max-width: 450px;
  border: 2px solid $primary;
  border-radius: 3px;
  height: 70px;
  @media only screen and (max-width: 600px) {
    max-width: 400px;
  }
  @media only screen and (max-width: 400px) {
    max-width: 350px;
  }
  .playlist-info {
    overflow: hidden;
    padding-left: 20px;
    background-color: transparent;
    border: none;
    cursor: default;
    display: grid;
    grid-template: "name nav" 1fr
                    "count nav" 1fr
                    /2fr 1fr;
    @media only screen and (max-width: 400px) {
      grid-template: "name nav" 1fr
                    "count nav" 1fr
                    /2.5fr 1fr;
    }

    .name {
      margin: 0 30px 0 20px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-align: left;
      padding-top: 5px;
      grid-column-start: 1;
      color: $primary;
      font-size: 24px;
      grid-area: name;

      @media only screen and (max-width: $phone-max-width) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      @media only screen and (max-width: 600px) {
        margin-left: 10px;
      }
      @media only screen and (max-width: 400px) {
        margin-left: 6px;
      }
    }

    .lyricsCount {
      grid-column-start: 1;
      grid-area: count;

      h2 {
        text-align: left;
        padding-top: 3px;
        padding-left: 20px;
        color: $grey-light;
        font-size: 12px;
        margin-top: 5px;
        margin-bottom: 0;
        @media only screen and (max-width: 600px) {
          padding-left: 10px;
        }
        @media only screen and (max-width: 400px) {
          padding-left: 6px;
          font-size: 11px;
          padding-right: 8px;
        }
      }
    }

    p {
      padding-right: 20px;
      grid-column-start: 2;
      grid-area: nav;
      position: relative;
      margin-bottom: auto;
      margin-top: auto;
      color: $dark-text;
      @media only screen and (max-width: 600px) {
        padding-right: 10px;
      }
      @media only screen and (max-width: 400px) {
        font-size: 0.7em;
        padding-right: 6px;
      }
    }
  }
}

.border-background {
  border-bottom: 4px ridge $dark-text;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  max-width: 435px;
  margin: 0 auto;
  @media only screen and (max-width: 600px) {
    max-width: 385px;
  }
  @media only screen and (max-width: 400px) {
    max-width: 300px;
  }
}

.border-background-second {
  border-bottom: 4px ridge $dark-text;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  max-width: 410px;
  margin: 0 auto 40px;
  @media only screen and (max-width: 600px) {
    max-width: 370px;
  }
  @media only screen and (max-width: 400px) {
    max-width: 260px;
  }
}

.ph-item {
  direction: ltr;
  position: relative;
  padding: 0;
  overflow: hidden;
  margin-bottom: 0;
  background-color: transparent;
  border: none;
  border-radius: none;

  &::before{
      display: none;
  }

  .ph-row{
      margin: 0;
  }

  .ph-col-12{
      margin: 0;
      padding: 0;
  }

  .big{
    height: 18px;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
    background-color: #727271;
    margin: 0;
    width: 70%;
    margin-bottom: 7.3px;

    &::before{
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 50%;
      width: 500%;
      margin-left: -250%;
      -webkit-animation: phAnimation 0.8s linear infinite;
      animation: phAnimation 0.8s linear infinite;
      background: linear-gradient(
          to right,
      rgba(255, 255, 255, 0) 46%,
      rgba(255, 255, 255, 0.35) 50%,
      rgba(255, 255, 255, 0) 54%) 50% 50%;
      z-index: 0;
    }
  }

  .gold{
    background-color: #d6ae5d;
    margin-top: 6px;
    width: 45%;
    margin-bottom: 0;
  }

  .ph-item > * {
    padding: 0;
  }
}
</style>